WB.Utility = WB.Utility || {};

import UuidGenerator from 'uuid/v4';

/*
 * Intercepts http request and adds X-RID header.
 */
WB.Utility.RequestIdHeaderInterceptor = function() {
    return {
        'request': function(config) {
            config.headers['X-RID'] = UuidGenerator();
            return config;
        },
    };
};
WB.Utility.RequestIdHeaderInterceptor.$inject = [];
WB.Core.factory('RequestIdHeaderInterceptor', WB.Utility.RequestIdHeaderInterceptor);
